(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-brand"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('brand-strip')) {
    class BrandStrip extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('[data-brand-viewport]');
        this.marquee = this.querySelector('[data-brand-marquee]');
        this.track = this.querySelector('[data-brand-track]');
        this.prevBtn = this.querySelector('[data-brand-prev]');
        this.nextBtn = this.querySelector('[data-brand-next]');

        this.handleScroll = this.rafThrottle(this.updateArrows.bind(this));
        this.handleResize = this.debounce(this.refresh.bind(this), 150);
        this.handlePrev = () => this.scrollByPage(-1);
        this.handleNext = () => this.scrollByPage(1);

        if (this.prevBtn) this.prevBtn.addEventListener('click', this.handlePrev);
        if (this.nextBtn) this.nextBtn.addEventListener('click', this.handleNext);
        if (this.viewport) this.viewport.addEventListener('scroll', this.handleScroll, { passive: true });
        window.addEventListener('resize', this.handleResize);

        // Recalculate once logos have actually painted (widths change the loop length).
        this.querySelectorAll('img').forEach((img) => {
          if (img.complete) return;
          img.addEventListener('load', this.handleResize, { once: true });
          img.addEventListener('error', this.handleResize, { once: true });
        });

        this.refresh();
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.handleResize);
        if (this.viewport) this.viewport.removeEventListener('scroll', this.handleScroll);
        if (this.prevBtn) this.prevBtn.removeEventListener('click', this.handlePrev);
        if (this.nextBtn) this.nextBtn.removeEventListener('click', this.handleNext);
      }

      get isMobile() {
        return window.matchMedia('(max-width: 749px)').matches;
      }

      refresh() {
        this.setMarqueeDuration();
        this.updateArrows();
      }

      /* Keep the marquee at a constant pixels-per-second speed regardless of
         how many logos there are or how wide they render. */
      setMarqueeDuration() {
        if (this.dataset.mobile !== 'marquee' || !this.marquee || !this.track) return;
        if (!this.isMobile) return;

        const speed = parseFloat(this.dataset.marqueeSpeed) || 40;
        const styles = window.getComputedStyle(this.marquee);
        const gap = parseFloat(styles.columnGap) || 0;
        const distance = this.track.getBoundingClientRect().width + gap;

        if (!distance || !speed) return;
        this.style.setProperty('--brand-marquee-duration', (distance / speed).toFixed(2) + 's');
      }

      scrollByPage(direction) {
        if (!this.viewport) return;
        const amount = this.viewport.clientWidth * 0.9;
        this.viewport.scrollBy({ left: direction * amount, behavior: 'smooth' });
      }

      updateArrows() {
        if (!this.viewport || (!this.prevBtn && !this.nextBtn)) return;

        const maxScroll = this.viewport.scrollWidth - this.viewport.clientWidth;
        const position = Math.abs(this.viewport.scrollLeft);
        const hasOverflow = maxScroll > 2;

        this.toggleAttribute('data-no-overflow', !hasOverflow);

        if (this.prevBtn) this.prevBtn.disabled = position <= 2;
        if (this.nextBtn) this.nextBtn.disabled = position >= maxScroll - 2;
      }

      rafThrottle(fn) {
        let ticking = false;
        return (...args) => {
          if (ticking) return;
          ticking = true;
          window.requestAnimationFrame(() => {
            ticking = false;
            fn(...args);
          });
        };
      }

      debounce(fn, wait) {
        let timer;
        return (...args) => {
          clearTimeout(timer);
          timer = setTimeout(() => fn(...args), wait);
        };
      }
    }

    customElements.define('brand-strip', BrandStrip);
  }

  } catch(e) { console.error(e); }
})();
})();
